<template>
  <v-layout justify-center>

    <v-dialog v-model="dialog_status"
      class="dialog-container"
      persistent width="540px"
      @keydown.esc="close()">

      <v-card v-if="!success">
        <!-- Title -->
        <v-card-title class="card-title">
          <span class="title-icon"><v-icon color="pms205">mdi-alert-circle-outline</v-icon></span>
          <span>BiblioTrees 이용권을 정말 해지하시겠어요?</span>
        </v-card-title>

        <!-- Text -->
        <v-card-text>
          <div>
            <ul>
              <li v-if="!!end_date">서비스는 현재 결제 주기 마지막 날인 {{ end_date }}에 종료됩니다.</li>
              <li>해지 후에는 현재 유효한 플랜으로만 재가입할 수 있습니다.</li>
              <li>회원님께서 서비스 기간 내 작성하신 내용은 보존되니 언제든 다시 플랜에 가입하셔서 연구를 이어나가보세요.</li>
            </ul>
          </div>
          <div class="text-boxes">
            <div class="text-box">
              <div class="list-title">🙆‍♂️ 최근에 추가된 기능들</div>
              <ul class="alert-list">
                <li>도큐먼트 복사/붙여넣기로 입력</li>
                <li>프로젝트간 도큐먼트 복사/이동</li>
                <li>트리 랭크 옵션 추가</li>
              </ul>
            </div>
            <div class="text-box">
              <div class="list-title">🙋‍♀️ 곧 추가될 기능들</div>
              <ul class="alert-list">
                <li>다양한 도큐먼트 트리</li>
                <li>프로젝트 관리창 신설</li>
                <li>도큐먼트 입력 과정 개선</li>
              </ul>
            </div>
          </div>

          <div v-if="error">
            <span class="required">
              <v-icon color="error" small>mdi-alert-circle-outline</v-icon>
              {{ $t('alert.try_again') }}
            </span>
          </div>
        </v-card-text>

        <v-card-actions class="actions">
          <v-spacer></v-spacer>
          <div class="buttons">
            <v-btn small text class="primary" @click="terminate()">
              해지하기
            </v-btn>
            <v-btn small text @click="close()">
              {{ $t('actions.cancel') }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>

      <v-card v-else>
        <!-- Title -->
        <v-card-title>
          <span>이용권 해지가 완료되었습니다.</span>
        </v-card-title>
        <!-- Actions -->
        <v-card-actions class="actions">
          <v-spacer></v-spacer>
          <div class="buttons">
            <v-btn small text @click="close()">
              {{ $t('actions.close') }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>

    </v-dialog>

  </v-layout>
</template>

<script>
import { toDatetimeLocal } from '../../../custom/function.js'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    }
  },

  data() {
    return {
      end_date: null,
      success: false,
      error: false,
    }
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },
  },

  watch: {
    async dialog(val) {
      if (val) {
        this.initiate()
        try {
          await this.$store.dispatch('user/getUserInfo')
        } catch(e) {
          this.$store.commit('error/setDialog', true)
        } finally {
          let membership = this.$store.getters['user/membership']
          let is_permanent = this.$store.getters['user/is_permanent']
          let user_type = this.$store.getters['user/user_type']
          if (!!membership) {
            if (!this.is_permanent&&(new Date(membership.end_date)).setHours(24, 0, 0, 0) > new Date().getTime()&&user_type!='premium') {
              this.end_date = this.toDatetimeLocal(new Date(membership.end_date)).substr(0, 10)
            } else {
              this.end_date = null
            }
          }
        }
      }
    },
  },

  methods: {
    toDatetimeLocal,

    initiate() {
      this.success = false
      this.error = false
    },

    close() {
      this.$emit('update:dialog', false)
    },

    async terminate() {
      this.initiate()
      try {
        await this.$store.dispatch('user/getMyAutoPayments')
      } catch(e) {
        this.error = true
        this.$store.commit('error/setDialog', true)
      } finally {
        if (!this.error) {
          let user_auto_payments = this.$store.getters['user/auto_payments']
          try {
            await this.$store.dispatch('payment/terminatePayletter', {
              auto_payment_id: user_auto_payments.slice(-1).pop().auto_payment_id
            })
          } catch(e) {
            this.error = true
            this.$store.commit('error/setDialog', true)
          } finally {
            if (!this.error) {
              this.success = true
            }
          }
        }
      }
    },
  },
}
</script>

<style scoped>
  .title-icon {
    transform: translateY(-2px);
    margin-right: 5px;
  }

  .list-title {
    font-weight: bold;
    font-size: 1.1rem;
  }

  .alert-list {
    list-style-type: circle;
    margin-top: 10px;
  }

  .text-boxes {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .text-box {
    margin-top: 10px;
    margin-right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/account/Terminate.vue